import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	chart: {
		info: { profiledUsers: 0, nonProfiledUsers: 0, customersPerTime: 0, totalCustomers: 0 },
		totalValue: { chart1: 0, chart2: 0 },
	},
	tableData: [{}],
};


export const CustomerSlice = createSlice({
	name: "customer",
	initialState,
	reducers: {
		updateCustCharts: (state, action) => {
			state.chart = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { updateCustCharts } = CustomerSlice.actions;

export default CustomerSlice.reducer;
